import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Box = styled.div<{ $isHidden?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 25px 3%;
  margin: 5px 0 20px;
  border-radius: 21px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    margin: 10px 0;
  }

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      display: none;
    `}
`;

export const Label = styled(Typography.Title)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const InputsRow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 3%;
  width: 60%;
  max-width: 535px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 2%;
    width: 100%;
    max-width: unset;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 38%;
  max-width: 345px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    max-width: unset;
  }
`;

export const ResetButton = styled(Button).attrs({
  appearance: 'transparent',
  height: 40,
  isFullWidth: true,
  hasPadding: false,
})`
  max-width: 100px;
  color: ${({ theme }) => theme.palette.primary.labels};
  text-decoration: underline;

  &:disabled {
    color: ${({ theme }) => theme.palette.tertiary.labels};
    cursor: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 33%;
    max-width: unset;
  }
`;

export const SearchButton = styled(Button).attrs({
  appearance: 'secondary',
  height: 50,
  borderRadius: 14,
  isFullWidth: true,
})`
  max-width: 230px;
  padding: 0 15px;
  text-wrap: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: auto;
  }

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.palette.system.deepBlue};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 48px;
    width: 62%;
    max-width: unset;
    min-width: 175px;
  }
`;
